var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.667 47.667L30.333 43.333L26 47.667V34.667H34.667V47.667ZM43.333 38.167C43.3328 39.8237 41.9898 41.167 40.333 41.167H37.917V34.667C37.917 32.8722 36.4618 31.4172 34.667 31.417H26C24.2051 31.417 22.75 32.8721 22.75 34.667V41.167H11.667C10.0102 41.167 8.66717 39.8237 8.66699 38.167V31.167C8.66699 29.5101 10.0101 28.167 11.667 28.167H43.333V38.167ZM40.333 4.33301C41.9898 4.33301 43.3328 5.6763 43.333 7.33301V24.917H15.167C12.6697 24.917 10.392 25.8563 8.66699 27.4004V7.33301C8.66717 5.6763 10.0102 4.33301 11.667 4.33301H40.333ZM17.333 16.792C16.4356 16.7921 15.708 17.5196 15.708 18.417C15.7082 19.3143 16.4357 20.0419 17.333 20.042H26C26.8973 20.0419 27.6248 19.3143 27.625 18.417C27.625 17.5196 26.8974 16.7921 26 16.792H17.333ZM17.333 9.20801C16.4358 9.20818 15.7082 9.9358 15.708 10.833C15.708 11.7304 16.4357 12.4578 17.333 12.458H34.667C35.5643 12.4578 36.292 11.7304 36.292 10.833C36.2918 9.9358 35.5642 9.20818 34.667 9.20801H17.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook03);
export default __webpack_public_path__ + "static/media/book03.206c25b943723e19867e3d7d61fa310f.svg";
export { ForwardRef as ReactComponent };